<template>
  <tab
        :index="tab"
        :loginRequired="loginRequired"
        :iframeDisplay="true"
        :init="init"
    />
</template>

<script>
import BaseIframe from './baseIframe.vue';

export default {
    extends: BaseIframe,
    props: ['tabIndex'],
    head() {
        return {};
    },
    data() {
        return {
            tab: this.tabIndex,
            height: 0
        };
    },
    computed: {
    },
    methods: {
        async getIframeUrl() {
            try {
                const result = await this.$urlApi.getNumberGame();
                return result;
            } catch (error) {
                this.$alertSystemMaintain();
            }
        }
    },
    mounted() {
    }
};
</script>
